import forecastLogo from 'src/assets/logo-forecast.png';
import { getFormattedTime, getPageCount, getPageWidth } from 'views/report/utils/utils.ts';
import { IProjectsOverview } from 'client/common/interfaces/project.ts';
import { blackColor, stoneGrayColor } from 'views/report/colors.ts';
import { fontNormal, padding } from 'views/report/utils/style-consts.ts';

export const addHeaderToPages = (doc: any, projectOverview: IProjectsOverview): void => {
  const { name, design } = projectOverview;

  const forecastLogoProps = doc.getImageProperties(forecastLogo);
  const forecastLogoWidth = 30;
  const forecastLogoHeight = (forecastLogoProps.height * forecastLogoWidth) / forecastLogoProps.width;

  for (let i = 1; i <= getPageCount(doc); i++) {
    if (i > 1) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.setTextColor(stoneGrayColor);
      doc.setFont(fontNormal.fontName, fontNormal.fontStyle);

      const dateText = getFormattedTime();

      doc.text(`${name} · ${design.name} · ${dateText}`, padding, padding + 1);
      doc.setTextColor(blackColor);

      const logoImageXPosition = getPageWidth(doc) - padding - forecastLogoWidth;
      const logoImageYPosition = padding / 2;

      doc.addImage(forecastLogo, 'PNG', logoImageXPosition, logoImageYPosition, forecastLogoWidth, forecastLogoHeight);
    }
  }
};
